var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9998 6.4165C16.0863 6.4165 6.4165 16.0863 6.4165 27.9998C6.4165 39.9133 16.0863 49.5832 27.9998 49.5832C39.9133 49.5832 49.5832 39.9133 49.5832 27.9998C49.5832 16.0863 39.9133 6.4165 27.9998 6.4165ZM2.9165 27.9998C2.9165 14.1533 14.1533 2.9165 27.9998 2.9165C41.8463 2.9165 53.0832 14.1533 53.0832 27.9998C53.0832 41.8463 41.8463 53.0832 27.9998 53.0832C14.1533 53.0832 2.9165 41.8463 2.9165 27.9998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1367 15.7729C28.1032 15.7729 28.8867 16.5565 28.8867 17.5229V27.0896C28.8867 27.4479 29.0235 27.9672 29.3277 28.5006C29.632 29.0341 30.0091 29.4158 30.3155 29.5974L30.3202 29.6002L30.3202 29.6002L37.5535 33.9169C38.3835 34.4122 38.6548 35.4865 38.1595 36.3164C37.6642 37.1464 36.5899 37.4177 35.7599 36.9224L28.5312 32.6085C28.5304 32.608 28.5296 32.6075 28.5288 32.607C27.5764 32.0419 26.811 31.1526 26.2874 30.2345C25.7632 29.3154 25.3867 28.2013 25.3867 27.0896V17.5229C25.3867 16.5565 26.1702 15.7729 27.1367 15.7729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.919023514e6ade0f87ca7891625ee188.svg";
export { ForwardRef as ReactComponent };